import { render, staticRenderFns } from "./GroupListDevManage.vue?vue&type=template&id=c1b43c3a&scoped=true"
import script from "./GroupListDevManage.vue?vue&type=script&lang=js"
export * from "./GroupListDevManage.vue?vue&type=script&lang=js"
import style0 from "./GroupListDevManage.vue?vue&type=style&index=0&id=c1b43c3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b43c3a",
  null
  
)

export default component.exports